export default "__VITE_ASSET__aIAMF20UzD_VyQXe4EAsmA__"